module.exports = __webpack_public_path__ + "img/refresh-black-24dp.cab801b8.svg";